import React from 'react'
import style from './style.module.scss'
import chessHeader from '@assets/images/chess/logo.png'
import chessLocation from '@assets/images/chess/location.svg'
import MyImage from '@shared/components/myImage'
import title from '@assets/images/chess/title.svg'
import subTitle from '@assets/images/chess/subTitle.svg'

function ChessHeader() {
  return (
    <header className={style.chessHeader}>
      <div className={style.info}>
        <div className={style.teamAndPlayers}>
          <div>
            <h2>6</h2>
            <p>Teams</p>
          </div>
          <div>
            <h2>36</h2>
            <p>Players</p>
          </div>
        </div>
        <div className={style.teamAndPlayers}>
          <div>
            <h2>6</h2>
            <p>Boards</p>
          </div>
          <div>
            <h2>60</h2>
            <p>Matches</p>
          </div>
        </div>
      </div>
      <div className={style.mainTitle}>
        <div className="d-flex gap-4 align-items-center">
          <div>
            <MyImage src={chessHeader} alt="Chess Header" height={118} width={58} />
          </div>
          <div className="d-flex flex-column justify-content-start align-items-start gap-4">
            <MyImage src={title} alt="Chess Title" />
            <MyImage src={subTitle} alt="Chess Subtitle" />
          </div>
        </div>
        <div className={style.location}>
          <MyImage src={chessLocation} alt="Chess Location" />
          London
        </div>
      </div>
      <div className={`${style.date} d-md-flex d-none`}>
        <p>3 Oct - 12 Oct 2024</p>
      </div>
      <div className={`d-md-none d-flex mt-4 ${style.mwebInfo}`}>
        <div>
          <h2>6</h2>
          <p>Teams</p>
        </div>

        <div>
          <h2>6</h2>
          <p>Boards</p>
        </div>
        <div>
          <h2>36</h2>
          <p>Players</p>
        </div>
        <div>
          <h2>60</h2>
          <p>Matches</p>
        </div>
      </div>
      <div className={`${style.date} d-md-none mt-4`}>
        <p>3 Oct - 12 Oct 2024</p>
      </div>
    </header>
  )
}

export default ChessHeader
